import { render, staticRenderFns } from "./ItemRefundSummaryList.vue?vue&type=template&id=66c74d8c&scoped=true&"
import script from "./ItemRefundSummaryList.vue?vue&type=script&lang=js&"
export * from "./ItemRefundSummaryList.vue?vue&type=script&lang=js&"
import style0 from "./ItemRefundSummaryList.vue?vue&type=style&index=0&id=66c74d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c74d8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c74d8c')) {
      api.createRecord('66c74d8c', component.options)
    } else {
      api.reload('66c74d8c', component.options)
    }
    module.hot.accept("./ItemRefundSummaryList.vue?vue&type=template&id=66c74d8c&scoped=true&", function () {
      api.rerender('66c74d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Refund/ItemRefundSummaryList.vue"
export default component.exports